module.exports = __webpack_public_path__ + "static/a-xx-174-art-629d7372ca7df6e18b734ea35e0ba96a.jpg";